var CallIn = function () { return import('~/pages/acc-manage/call-in.vue'); };
export default [
    {
        path: '/acc-manage/call-in',
        name: 'call-in',
        component: CallIn
    }
];
